<template>
  <div>
    <img src="../assets/img/crm-banner.png" width="100%" alt="">
    <Modular obj="CRM" name="modular1"></Modular>
    <Modular obj="CRM" name="modular2"></Modular>
    <Modular obj="CRM" name="modular3"></Modular>
    <Modular obj="CRM" name="modular4"></Modular>
    <Modular obj="CRM" name="modular5"></Modular>
    <Modular obj="CRM" name="modular6"></Modular>
    <News></News>
  </div>
</template>
<script>
// import  Api from '../api/http.js'
import Modular from '../components/Modular'
import News from '../components/MNews'
export default {
  components: {
    Modular,
    News
  },
  data(){
    return {
      news:[]
    }
  },
  created(){
  },
  methods:{

  }
}
</script>

<style lang="scss">

</style>
